(() => {
  if (customElements.get('bt-footer-accordion')) return;
  customElements.define('bt-footer-accordion', class extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.panel || !this.summary) return;
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.sync = () => {
        this.panel.open = this.desktop.matches;
        if (this.desktop.matches) this.summary.setAttribute('tabindex', '-1');
        else this.summary.removeAttribute('tabindex');
      };
      this.onClick = event => {
        if (this.desktop.matches) event.preventDefault();
      };
      this.summary.addEventListener('click', this.onClick);
      this.desktop.addEventListener('change', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      this.summary?.removeEventListener('click', this.onClick);
      this.desktop?.removeEventListener('change', this.sync);
    }
  });
})();
